import axiosClient from "./axiosClient";

const globalApi = {
  LoginDevPage: (password) => {
    let data = {
      password: password,
    };
    return axiosClient.post(`/global/login-dev-page`, data, {
      withCredentials: true,
    });
  },
};

export default globalApi;
